/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import TicketImg from '../../Assets/tickimg.png';
import LyftImg from '../../Assets/lyftimg.png';
import lyftCheckBox from "../../Assets/lyftCheckBox.png";
import kalamFont from '../../font/Kalam-Light.ttf';
import '../../font/registerPatrickHandAndCaveatPdf';

Font.register({ family: 'kalamFont', format: "truetype", src: kalamFont });


const styles = StyleSheet.create({
  body: {
    paddingBottom: 5,
  },
  headerWidth: {
    marginBottom: "25px",
  },
  header: {
    backgroundColor: "#00B3AD",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
  },
  imgwrap:{
    flexDirection:"row",
    alignItems: "center",

  },
  textborder:{
     marginLeft:"20px",
     color:"white",
     borderLeft:"1px solid white",
     paddingLeft:"20px",
     height:"100%",
      textTransform:"uppercase",
     fontWeight:"bold"
  },
  californiaText: {
    color: "white",
    fontSize: "20px",
    textTransform: "uppercase",
  },
  boxContainer: {
    padding: "10px",
  },
  lyftdrivertextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent:"space-between",
    marginBottom: "15px",
  },
  boxWidth: {
    paddingHorizontal: 20,
  },
  lyftdriverText: {
    fontSize: "24px",
    fontStyle: "sans-serif",
    fontWeight: "bold",
    color: "black",
    float: "left"
  },
  allfieldsText: {
    color: "black",
    fontSize: "18px",
    fontWeight: "400",
    marginLeft: "200px",
  },
  nameinputContainer: {
    marginTop: "10px",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "30px"
  },
  nameinputContain: {
    marginTop: "10px",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px"
  },
  lyftdriverName: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    color: "#47484F",
    marginBottom: 0,
    marginTop: "3px",
  },
  lyftdriver: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400",
    color: "#47484F",
    marginBottom: 0,
    marginTop: "3px",
    borderTop: "3px solid #A6A4A4",
    paddingTop: "5px"
  },
  nameText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    textAlign: "center",
    color: "black",
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "30px"
  },
  nameinputContainerOne: {
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerTwo: {
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerThree: {
    marginTop: "10px",
    width: "40%",
  },
  threeinputFields: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    color: "black",
    textAlign: "center",
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputField: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    color: "black",
    paddingLeft: "20px",
    borderBottom: "3px solid #A6A4A4"
  },
  threeinputFieldsStreetAddress: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "300",
    color: "black",
    textAlign: "center",
    borderBottom: "3px solid #A6A4A4"
  },
  licenseplateContainer: {
    width: "45%",
    marginRight: "10px",
  },
  codeText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "300",
    color: "black",
    marginLeft: "50%",
  },
  vinContainer: {
    fontSize: "12px",
    fontWeight: "30",
    fontStyle: "normal",
    color: "black",
  },
  twoinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "10px",
  },
  vintopBorder: {
    borderTopWidth: 1,
    borderTopColor: "#47484F",
    width: "100%",
  },
  topText: {
    marginTop: "30px",
    fontSize: "12px",
    paddingLeft: "8px",
    paddingRight: "10px",
  },
  vehicleinspectionPadding: {
    paddingHorizontal: "30px",
    paddingTop: "10px",
  },
  checkboxesmainContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
  },
  checkboxesmainContainerTwo: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
    marginTop: "10px",
  },
  inspectionfirstContainer: {
    width: "94%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionsecondContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionText: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  detailsText2: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '400',
    color: 'gray',
    marginLeft: '25px',
  },
  inspectiontextTwo: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#716E6E",
    marginLeft: "15px",
    textTransform: "uppercase",
  },
  passText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#716E6E",
    marginRight: "15px",
    textTransform: "uppercase",
  },
  failText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  passfailContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  passfailContainer1: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft:"223px"
  },
  numbersText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "#716E6E",
  },
  detailsText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    color: "black",
    marginLeft: "5px",
  },
  failpassbox: {
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "black",
    marginLeft: "15px",
    width: "92%",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    position: "absolute",
    height: "60px",
    top: 10,
  },

  boxinspectionText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    color: "black",
    textTransform: "uppercase",
  },
  circleoneText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    color: "#716E6E",
    marginTop: "5px",
  },
  boxpassText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "black",
  },
  orangeCircle: {
    borderWidth: 5,
    borderColor: "#FC6522",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  boxfailText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    color: "black",
  },
  boxinspectionContainer: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  tobecompletedContainer: {
    backgroundColor: "#E4E5E7",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedWidth: {
    paddingHorizontal: "30px",
    marginTop: '10px',
  },
  tobecompletedtextContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedText: {
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "700",
    color: "black",
    textDecoration: "underline",
    textTransform: "uppercase",
  },
  fieldsText: {
    fontSize: 10,
    fontStyle: "normal",
    fontWeight: "700",
    color: "#716E6E",
    textTransform: "uppercase",
  },

  inpectionText: {
    fontSize: "16px",
    color: "#47484F",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  documentexpiryText: {
    fontSize: "12px",
    color: "#47484F",
  },
  dateText: {
    fontSize: "16px",
    letterSpacing: "1px",
  },
  datemainContainer: {
    marginTop: "10px",
    marginLeft: "52%",
  },
  namesfieldscontainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "18px",
    alignItems: "flex-end",
  },
  borderWidth: {
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  topName: {
    fontSize: "14px",
    color: "black",
    marginLeft: "12px",
  },
  bottomName: {
    fontSize: "12px",
    color: "#47484F",
    textTransform: "uppercase",
  },
  bottomPara: {
    paddingHorizontal: "30px",
    fontSize: 10,
    marginTop: "15px",
    color: "#716E6E",
  },
  tickpassContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  tickfailContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  inspectiondateContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "95%",
  },
});

function LyftCertificateAlabamaDownLoad ({
  checksData,
  reportData,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };

    const checksname=[
        {
          id:1,
         name:"Left front"
        },
        {
          id:2,
          name:"Right front"
        },
       {
        id:3,
        name:"Left rear"
       },
       {
        id:4,
        name:"Right rear"
       }
      ]

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              <View style={styles.headerWidth}>
                <View style={styles.header}>
                <View style={styles.imgwrap}>
                  <Image style={{ width: "40px" }} source={LyftImg} />
                  </View>
                  <Text style={[styles.californiaText, { fontWeight: "bold" }]}>
                    ALABAMA
                  </Text>
                </View>
              </View>
              <View style={{ paddingHorizontal: "30px", marginBottom: "15px" }}>
                <Text style={{ fontSize: "14px", color: "#3a3b43", lineHeight: 1.35, fontWeight: "bold", textAlign: "center" }}>
                  Note: This inspection shall be performed by an American Advanced Technicians Institute (AATI) certified mechanic or a National Institute for Automotive Service Excellence (ASE) certified mechanic or by a mechanic that is under the supervision of an AATI or ASE certified mechanic.
                </Text>
              </View>
              <View style={styles.boxWidth}>
                <View style={styles.boxContainer}>
                  <View style={styles.lyftdrivertextContainer}>
                    <Text style={styles.lyftdriverText}>LYFT DRIVER INFO</Text>
                    <Text style={styles.allfieldsText}>
                      ALL FIELDS ARE MANDATORY
                    </Text>
                  </View>

                  <View style={styles.nameinputContainer}>
                    <View style={{ width: "50%", marginRight: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && `${reportData?.Username} ${reportData?.UserlastName}`}
                      </Text>
                      <Text style={styles.lyftdriverName}>LYFT DRIVER NAME</Text>
                    </View>
                    <View style={{ width: "50%", marginLeft: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && reportData?.Useremail}
                      </Text>
                      <Text style={styles.lyftdriverName}>EMAIL ADDRESS</Text>
                    </View>
                  </View>
                  <View style={styles.threeinputfieldContainer}>
                    <View style={styles.nameinputContainerOne} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.licensePlateNumber}
                      </Text>
                      <Text style={styles.lyftdriverName}>LICENSE PLATE #</Text>
                    </View>
                    <View style={[styles.nameinputContainerTwo, { width: "auto", flexGrow: 1, marginRight: 0 }]} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.vin}
                      </Text>
                      <Text style={styles.lyftdriverName}>VIN #</Text>
                    </View>
                  </View>
                  <View style={styles.twoinputfieldContainer}>
                    <View style={styles.licenseplateContainer} >
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.make}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MAKE</Text>
                    </View>
                    <View style={{ width: "32%", marginRight: "10px", marginLeft: "5px" }}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.model}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE MODEL</Text>
                    </View>
                    <View style={{ width: "20%", marginLeft: "18px" }}>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {reportData && reportData.year}
                      </Text>
                      <Text style={styles.lyftdriverName}>VEHICLE YEAR</Text>
                    </View>
                  </View>
                  <View style={styles.nameinputContain}>
                    <View style={{ width: "45%", marginRight: "10px", marginTop: "15px" }}>
                      <Text style={styles.lyftdriver}>LYFT DRIVER SIGNATURE</Text>
                    </View>
                    <View style={{ width: "55%", marginLeft: "10px" }}>
                      <Text style={[styles.nameText, handwritingStyle]}>
                        {reportData && reportData?.Userphone}
                      </Text>
                      <Text style={styles.lyftdriverName}>LYFT DRIVER PHONE NUMBER</Text>
                    </View>
                  </View>
                </View>
              </View>
              {/* height converted from 38% of A3 (page is now auto-height) to a fixed value */}
              <View style={{ marginLeft: "20px", height: 452 }}>
                <View style={{ flexWrap: "wrap", flexDirection: "row", alignSelf: 'center'}}>
                  <Image
                    style={{
                      width: "100%",
                      height: "100%",
                      marginLeft: -10,
                    }}
                    source={lyftCheckBox}
                  />
                </View>
              </View>
              <View style={styles.tobecompletedWidth}>
                <View style={styles.tobecompletedContainer}>
                  <View style={{ width: "50%", marginLeft: "20px", marginTop: "10px", marginRight: "20px" }}>
                    <Text>TO BE COMPLETED BY INSPECTOR</Text>
                  </View>
                </View>
                <View style={styles.tobecompletedContainer}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>Chex Inc.</Text>
                    <Text style={styles.lyftdriverName}>COMPANY/FACILITY NAME</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{`${reportData && reportData?.Inspectorname} ${reportData && reportData?.InspectorlastName}`}</Text>
                    <Text style={styles.lyftdriverName}>INSPECTOR NAME</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-end" }]}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputFieldsStreetAddress, handwritingStyle]}>{reportData && reportData?.stateAddress}</Text>
                    <Text style={styles.lyftdriverName}>COMPANY/FACILITY ADDRESS</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }} >
                    <Text style={[styles.threeinputField, handwritingStyle]}>
                      {moment(
                        new Date(
                          reportData &&
                          reportData?.reviewedDate
                        )
                      ).format("MM/ DD /YYYY")}
                    </Text>
                    <Text style={styles.lyftdriverName}>INSPECTION DATE (document expires one year from this date)</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-end" }]}>
                  <View style={{ width: "50%", marginRight: "20px", marginLeft: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{(reportData && reportData?.milage) || " "}</Text>
                    <Text style={styles.lyftdriverName}>VEHICLE MILEAGE</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }} >
                    <Text style={[styles.threeinputField, handwritingStyle]}>{(reportData && reportData?.aseCertificationNumber) || " "}</Text>
                    <Text style={styles.lyftdriverName}>ASE/AATI CERTIFICATION NO.</Text>
                  </View>
                </View>
                <View style={[styles.tobecompletedContainer, { alignItems: "flex-start" }]}>
                  <View style={{ width: "50%", marginLeft: "20px", marginRight: "20px", marginBottom: "10px" }}>
                    <View style={{ position: "relative" }}>
                      {reportData && reportData?.Inspectorsignature ? (
                        <Image
                          style={{ position: "absolute", bottom: 0, left: "20px", height: "50px", width: "150px", objectFit: "contain" }}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${reportData.Inspectorsignature}?x-request=xhr`}
                        />
                      ) : null}
                      <Text style={[styles.threeinputField, handwritingStyle]}>{" "}</Text>
                    </View>
                    <Text style={styles.lyftdriverName}>INSPECTOR SIGNATURE</Text>
                  </View>
                  <View style={{ width: "50%", marginRight: "20px", marginBottom: "10px" }}>
                    <Text style={[styles.threeinputField, handwritingStyle]}>{" "}</Text>
                    <Text style={styles.lyftdriverName}>NAME OF SUPERVISING AATI OR ASE CERTIFIED MECHANIC (IF DIFFERENT FROM ABOVE)</Text>
                  </View>
                </View>
              </View>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const LyftCertificateAlabamaDownLoadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template3");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <LyftCertificateAlabamaDownLoad
            key={cfg.handwritingFont}
            reportData={reportData}
            certificateData={reportData}
            checksData={checksData}
            checks={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.lyftVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setLyftReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LyftCertificateAlabamaDownLoadConnected);
